export const dataStates = [
    { text: 'AC', value: 'AC' },
    { text: 'AL', value: 'AL' },
    { text: 'AP', value: 'AP' },
    { text: 'AM', value: 'AM' },
    { text: 'BA', value: 'BA' },
    { text: 'CE', value: 'CE' },
    { text: 'DF', value: 'DF' },
    { text: 'ES', value: 'ES' },
    { text: 'GO', value: 'GO' },
    { text: 'MA', value: 'MA' },
    { text: 'MT', value: 'MT' },
    { text: 'MS', value: 'MS' },
    { text: 'MG', value: 'MG' },
    { text: 'PA', value: 'PA' },
    { text: 'PB', value: 'PB' },
    { text: 'PR', value: 'PR' },
    { text: 'PE', value: 'PE' },
    { text: 'PI', value: 'PI' },
    { text: 'RJ', value: 'RJ' },
    { text: 'RN', value: 'RN' },
    { text: 'RS', value: 'RS' },
    { text: 'RO', value: 'RO' },
    { text: 'RR', value: 'RR' },
    { text: 'SC', value: 'SC' },
    { text: 'SP', value: 'SP' },
    { text: 'SE', value: 'SE' },
    { text: 'TO', value: 'TO' }
];

export const dataSex = [
    {
        text: 'Masculino',
        value: 'masculino'
    },
    {
        text: 'Feminino',
        value: 'feminino'
    }
];

export const dataCivilStatus = [
    {
        text: 'Casado(a) e/ou residente com companheiro(a)',
        value: 'casado'
    },
    {
        text: 'Solteiro(a)',
        value: 'solteiro'
    },
    {
        text: 'Viúvo(a)',
        value: 'viuvo'
    },
    {
        text: 'Divorciado(a)',
        value: 'divorciado'
    }
];

export const dataVehicleUse = [
    {
        text: 'Particular',
        value: 'particular'
    },
    {
        text: 'Motorista de App',
        value: 'motorista_app'
    },
    {
        text: 'Taxi',
        value: 'taxi'
    },
    {
        text: 'Comercial',
        value: 'comercial'
    },
];

export const dataInsuredBondLegal = [
    {
        text: 'Sócio/Proprietário/Presidente/Vice-Presidente',
        value: 'socio'
    },
    {
        text: 'Diretor/Gerente',
        value: 'gerencia'
    },
    {
        text: 'Empregado/Funcionário/Motorista da Empresa',
        value: 'colaborador'
    },
    {
        text: 'Outro',
        value: 'outros'
    },
];

export const dataInsuredBondPhysical = [
    {
        text: 'Filho (a), enteado (a)',
        value: 'filho'
    },
    {
        text: 'Irmão (ã); avô, avó; neto (a)',
        value: 'irmao'
    },
    {
        text: 'Cônjuge ou companheiro (a) (união estável)',
        value: 'conjuge'
    },
    {
        text: 'Outros',
        value: 'outros'
    },
];

export const dataTaxExemptionReason = [
    {
        text: 'PCD (Pessoa com deficiência)',
        value: 'pcd'
    },
    {
        text: 'Outro',
        value: 'outros'
    }
];

export const ParseCivilStatus = (civilStatus: string) => {
    switch (civilStatus) {
        case 'Casado':
            return { text: 'Casado(a) e/ou residente com companheiro(a)', value: 'casado' };
        case 'Solteiro':
            return { text: 'Solteiro(a)', value: 'solteiro' };
        case 'Viúvo(a)':
            return { text: 'Viúvo(a)', value: 'viuvo' };
        case 'Viúvo':
            return { text: 'Viúvo(a)', value: 'viuvo' };
        case 'Divorciado':
            return { text: 'Divorciado(a)', value: 'divorciado' };
        default:
            return { text: '', value: '' };
    }
}

export const ParseVehicleUse = (vehicleUse: string) => {
    switch (vehicleUse) {
        case 'Particular':
            return { text: 'Particular', value: 'particular' };
        case 'Motorista de App':
            return { text: 'Motorista de App', value: 'motorista_app' };
        case 'Motoriasta App':
            return { text: 'Motorista de App', value: 'motorista_app' };
        case 'Motorista App':
            return { text: 'Motorista de App', value: 'motorista_app' };
        case 'Taxi':
            return { text: 'Taxi', value: 'taxi' };
        case 'Comercial':
            return { text: 'Comercial', value: 'comercial' };
        default:
            return { text: '', value: '' };
    }
}

export const ParseTaxExemptionReason = (taxExemptionReason: string) => {
    switch (taxExemptionReason) {
        case 'PCD (Pessoa com deficiência)':
            return { text: 'PCD (Pessoa com deficiência)', value: 'pcd' };
        case 'Taxi':
            return { text: 'Taxi', value: 'taxi' };
        case 'Outro':
            return { text: 'Outro', value: 'outros' };
        default:
            return { text: '', value: '' };
    }
}

export const ParseInsuredBond = (insuredBond: string) => {
    switch (insuredBond) {
        case 'Sócio/Proprietário/Presidente/Vice-Presidente':
            return { text: 'Sócio/Proprietário/Presidente/Vice-Presidente', value: 'socio' };
        case 'Diretor/Gerente':
            return { text: 'Diretor/Gerente', value: 'gerencia' };
        case 'Empregado/Funcionário/Motorista da Empresa':
            return { text: 'Empregado/Funcionário/Motorista da Empresa', value: 'colaborador' };
        case 'Filho (a), enteado (a)':
            return { text: 'Filho (a), enteado (a)', value: 'filho' };
        case 'Irmão (ã); avô, avó; neto (a)':
            return { text: 'Irmão (ã); avô, avó; neto (a)', value: 'irmao' };
        case 'Cônjuge ou companheiro (a) (união estável)':
            return { text: 'Cônjuge ou companheiro (a) (união estável)', value: 'conjuge' };
        case 'Outro':
            return { text: 'Outro', value: 'outros' };
        case 'Outros':
            return { text: 'Outro', value: 'outros' };
        default:
            return { text: '', value: 'outros' };
    }
}
